// import { config } from "./config.ts";

export function goTo(url: string) {
  // switch (url) {
  //   case "home":
  //     url = config.baseUrl;
  //     break;
  //   case "gallery":
  //     url = config.baseUrl + "/gallery";
  //     break;
  //   case "login":
  //     url = config.baseUrl + "/login";
  //     break;
  //   default:
  //     url = config.baseUrl + (url.startsWith("/") ? url : "/" + url);
  // }
  if (!url.startsWith("http")) {
    if (!url.startsWith("/")) {
      url = "/" + url;
    }
    if (window.location.pathname === url) {
      return;
    }
  }
  window.location.href = url;
}

export function goHome() {
  return goTo("/");
}

// export function appendTokenToUrl(url: string) {
//   const token = getAuthToken();
//   if (!token) return url;
//   const separator = url.includes("?") ? "&" : "?";
//   return `${url}${separator}token=${encodeURIComponent(token)}`;
// }

export function setTitle(title: string) {
  document.title = title;
}
